import AlphaSidebar from './alpha'
import BetaSidebar from './beta'
import DeltaSidebar from './delta'

export const Alpha = AlphaSidebar
export const Beta = BetaSidebar
export const Delta = DeltaSidebar
